import React, { useContext } from "react";
import profile_avtr from "../../assets/profile/profile_avtr.png";
import profile_icon from "../../assets/profile/profile_icon.png";
import address_icon from "../../assets/profile/address_icon.png";
import order_icon from "../../assets/profile/order_icon.png";
import wishlist_icon from "../../assets/profile/wishlist_icon.png";
import logout_icon from "../../assets/profile/logout_icon.png";
// import sms_icon from "../../assets/profile/sms_icon.png";
import phone_icon from "../../assets/profile/phone_icon.png";
import email_icon from "../../assets/profile/email_icon.png";
import Profile from "./Profile";
import Address from "./Address";
import Orders from "./Orders";
import Wishlist from "./Wishlist";
// ... imports remain the same
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import Chatlottie from "../../assets/animations/Chat.lottie";
import { AppContext } from "../../context/AppContext";
const ProfileTab = () => {
  const { activeTab, setActiveTab } = useContext(AppContext);
  const menuItems = [
    { id: "profile", label: "Your Profile", icon: profile_icon },
    { id: "address", label: "Address", icon: address_icon },
    { id: "orders", label: "Orders", icon: order_icon },
    { id: "wishlist", label: "Wishlist", icon: wishlist_icon },
    { id: "logout", label: "Logout", icon: logout_icon },
  ];
  return (
    <div className="bg-[#f5f6f1] pt-20 md:pt-28 mx-auto w-full pb-10 xl:pb-36">
      <div className="grid grid-cols-12 w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[88rem] mx-auto px-4 md:px-2 gap-6 md:gap-8 ">
        {/* Left Tab: Sidebar */}
        <div className="xl:col-span-4 col-span-12">
          <div className="bg-white px-4 md:px-6 flex flex-col xl:pb-0 pb-4 xl:pt-8 pt-4 rounded-[10px] shadow-sm">
            <div className="flex flex-row gap-4 xl:gap-6 items-center">
              <img
                src={profile_avtr}
                alt="avatar"
                className="w-14 h-14 xs:w-12 xs:h-12 md:w-20 md:h-20 object-cover"
              />
              <div>
                <h2 className="text-lg xs:text-sm md:text-[26px] leading-tight font-lexend font-semibold text-[#2a552f]">
                  Hi, John Doe
                </h2>
                <p className="text-sm md:text-2xl text-[#a8a8a8] font-lexend font-normal">
                  Good Morning
                </p>
              </div>
            </div>

            {/* Menu Items */}
            <div className="xl:block hidden pt-7 mb-4">
              {menuItems.map((item) => (
                <div
                  key={item.id}
                  onClick={() => setActiveTab(item.id)}
                  className={`w-full flex flex-row items-center md:py-4 py-2.5 px-4 md:px-6 ${
                    item.id === "logout" ? "" : "border-b"
                  } border-[#d9eada] gap-4 md:gap-6 cursor-pointer transition-colors
                  ${activeTab === item.id ? "bg-[#e9f6e8] rounded-md" : ""}`}
                >
                  <img src={item.icon} alt="" className="sm:w-6 sm:h-6 " />
                  <h2
                    className={`text-base md:text-xl font-lexend ${
                      activeTab === item.id
                        ? "font-bold text-[#2a552f]"
                        : "font-normal text-gray-600"
                    }`}
                  >
                    {item.label}
                  </h2>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Middle Tab: Content Area */}
        <div className="xl:col-span-5 col-span-12">
          <div className="lg:min-h-[300px]">
            {activeTab === "profile" && <Profile />}
            {activeTab === "address" && <Address />}
            {activeTab === "orders" && <Orders />}
            {activeTab === "wishlist" && <Wishlist />}
          </div>
        </div>

        {/* Right Tab: Help/Support */}
        <div className="xl:col-span-3 col-span-12">
          <div className="bg-white flex flex-col px-4 md:px-6 sm:py-6 py-8 md:py-10 rounded-[10px] sm:gap-1 gap-4 border-[#8dba93] border shadow-sm">
            <div className="flex items-center justify-center">
              {/* <img src={sms_icon} alt="support" className="w-20 md:w-auto" /> */}
              <DotLottieReact
                src={Chatlottie}
                loop
                autoplay
                className="h-[105px]"
              />
            </div>
            <h3 className="text-xl sm:text-base sm:px-10 md:text-2xl text-[#2a552f] font-lexend font-semibold text-center leading-tight">
              Need help choosing <br className="hidden md:block" /> the right
              mattress?
            </h3>
            <p className="text-sm md:text-lg text-center md:px-4 lg:px-8 text-[#808080] font-lexend font-normal">
              Get in touch with our sleep experts
            </p>
            <div className="flex sm:flex-row flex-col items-center justify-center gap-3 xs:px-2 mt-2">
              <button className="flex justify-center items-center gap-3 rounded-lg bg-[#2a552f] w-full  md:max-w-[200px] py-3 text-[#f4e390] hover:bg-[#1e3d22] transition-colors">
                <img src={phone_icon} alt="" className="w-4 h-4" />
                <span className="text-base sm:text-sm md:text-xl font-lexend font-semibold">
                  Call us
                </span>
              </button>
              <button className="flex justify-center items-center gap-3 rounded-lg bg-[#2a552f] w-full max-w-[200px] py-3 text-[#f4e390] hover:bg-[#1e3d22] transition-colors">
                <img src={email_icon} alt="" className="w-4 h-4" />
                <span className="text-base sm:text-sm md:text-xl font-lexend font-semibold">
                  Email us
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileTab;
